import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";

export const useInboundFreightByTerminal = (
  originCity?: string | null,
  status?: string | null,
  manifest?: string | null,
  trailer?: string | null,
  etaFrom?: string | null,
  etaTo?: string | null
) => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<any[]>({
      queryKey: [QUERY_KEYS.INBOUND_FREIGHT_BY_TERMINAL, originCity, status, manifest, trailer, etaFrom, etaTo],
      queryFn: async () => {
        let params: any = {};
        if (originCity) {
          params.originCity = originCity;
        }
        if (status) {
          params.status = status;
        }
        if (manifest) {
          params.manifest = manifest;
        }
        if (trailer) {
          params.trailer = trailer;
        }
        if (etaFrom) {
          params.etaFrom = etaFrom;
        }
        if (etaTo) {
          params.etaTo = etaTo;
        }

        const response = await apiQueryAdapter.query<any[]>(`/linehaul-manifests/terminal/${userState.activeTerminal?.id}`,
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}